import { useTranslation } from 'react-i18next';

export function DevelopmentPreviewNotice() {
  const { t } = useTranslation('travelCari');
  if (!import.meta.env.DEV || import.meta.env.VITE_DEV_PREVIEW_READ_ONLY !== 'true') return null;
  return (
    <div role="status" className="bg-muted border-b px-5 py-2 text-center text-xs">
      {t('account.readOnlyNotice')}
    </div>
  );
}
